import styled from "@emotion/styled";
import { DrawerProps } from "@mui/material";

import Drawer from "@mui/material/Drawer";
export const Drawerinfo = styled((props: DrawerProps & { is_mobile: string; show_role_info: string; half_hidden: string }) => <Drawer {...props} />)(
    ({ theme, show_role_info, half_hidden, is_mobile }) => ({
        "& .MuiDrawer-paper": {
            backgroundColor: "#1C1359",
            ml: "98px",
            display: show_role_info === "true" ? "block" : "none",
            top: "71px",
            width: half_hidden === "true" ? "50px" : show_role_info ? "371px" : "0px",
            position: "fixed",
            zIndex: "1000",
            transition: "width 0.3s linear",
        },
        "@media (min-width: 300px) and (max-width: 600px)": {
            "& .MuiDrawer-paper": {
                top: "0px",
                width: "100vw",
                display: is_mobile === "true" ? "block" : "none",
            },
            "#filter-mobile": {
                display: "none !important",
            },
        },
    })
);
